import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CodeListDescriptor } from './model/codelist';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class CodeListService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'CodeListManagement',
      authService,
      config.CLMSConfig
    );
  }

  public create(codelist: CodeListDescriptor): Promise<CodeListDescriptor> {
    return super.post<CodeListDescriptor>(
      new CodeListDescriptor({
        id: undefined,
        href: undefined,
        name: codelist.name,
        description: codelist.description,
        codeListType: codelist.codeListType,
        codeListFilterType: codelist.codeListFilterType,
        formId: codelist.formId,
        organizationId: codelist.organizationId,
        codeListDataEntryFilterType: codelist.codeListDataEntryFilterType,
        nameField: codelist.nameField,
        descriptionField: codelist.descriptionField,
        organizationMekhCodeField: codelist.organizationMekhCodeField,
        referenceField: codelist.referenceField,
        validFromField: codelist.validFromField,
        validUntilField: codelist.validUntilField,
        storedProcedureName: codelist.storedProcedureName,
        modified: codelist.modified,
        deleted: codelist.deleted
      }));
  }

  public getCodeLists(view?: View): Promise<List<CodeListDescriptor>> {
    return super.get<List<CodeListDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: CodeListDescriptor): Promise<CodeListDescriptor> {
    return super.put<CodeListDescriptor>(id, role);
  }

  public getById(id: string): Promise<CodeListDescriptor> {
    return super.get<CodeListDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/codelist/codelist.service.ts